<template>
  <span>
    <el-popover v-model="visible" trigger="click" placement="top" width="340">
      <div class="materel-popoverr">
        <div class="material-popover__title">设置面料材质</div>
        <div style="padding: 10px;">
          <el-input v-model="materialText" placeholder="请输入面料材质"></el-input>
        </div>
        <div class="material-popover__footer">
          <el-button size="mini" @click.stop="onCancel">取 消</el-button>
          <el-button size="mini" type="primary" @click.stop="onConfirm">确 认</el-button>
        </div>
      </div>
      <el-button slot="reference"> 智能填充 </el-button>
    </el-popover>
    <el-popover placement="bottom" width="400" trigger="hover" style="margin-left: 4px">
      <div class="parse-helper">
        <div class="parse-helper__header">
          <span class="parse-helper__before-title">解析前</span>
          <span class="parse-helper__arrow-title">➤➤</span>
          <span class="parse-helper__after-title">解析后</span>
        </div>
        <ul class="parse-helper__list">
          <li class="parse-helper__row">
            <span class="parse-helper__before">95%棉+5%氨纶</span>
            <span class="parse-helper__arrow">➤➤</span>
            <span class="parse-helper__after">棉95% 氨纶5%</span>
          </li>
          <li class="parse-helper__row">
            <span class="parse-helper__before">95%棉 5%氨纶</span>
            <span class="parse-helper__arrow">➤➤</span>
            <span class="parse-helper__after">棉95% 氨纶5%</span>
          </li>
          <li class="parse-helper__row">
            <span class="parse-helper__before">95%棉5%氨纶</span>
            <span class="parse-helper__arrow">➤➤</span>
            <span class="parse-helper__after">棉95% 氨纶5%</span>
          </li>
          <li class="parse-helper__row">
            <span class="parse-helper__before">100%棉</span>
            <span class="parse-helper__arrow">➤➤</span>
            <span class="parse-helper__after">棉100%</span>
          </li>
          <li class="parse-helper__row">
            <span class="parse-helper__before">棉</span>
            <span class="parse-helper__arrow">➤➤</span>
            <span class="parse-helper__after">棉100%</span>
          </li>
        </ul>
      </div>
      <i slot="reference" class="el-icon-info"></i>
    </el-popover>
  </span>
</template>

<script>
export default {
  name: 'material-auto-parse',
  props: {},
  data() {
    return {
      materialText: '',
      visible: false,
    };
  },
  methods: {
    parseMaterial(value) {
      if (!value || typeof value !== 'string') return [];
      let text = value
        .replace(/％/g, '%')
        .replace(/[+，、；;]+/g, ' ')
        .trim()
        .replace(/\s+/g, ' ');
      if (!text) return [];

      const segs = text.split(' ');
      const results = [];
      const nameReg = /^[A-Za-z\u4e00-\u9fa5]+$/;
      const percentReg = /^\d+(?:\.\d+)?%?$/;

      const pushRes = (name, pct) => {
        if (!name) return;
        const p = pct === undefined || pct === null || pct === '' ? '100' : String(pct).replace('%', '');
        results.push({ valueName: name, percentageValue: p, unitName: '%' });
      };

      for (let i = 0; i < segs.length; i++) {
        const seg = segs[i];
        if (!seg) continue;

        // 先处理连写情况：如 95%棉5%氨纶、棉95%氨纶5%
        const concatPairs = seg.matchAll(/(\d+(?:\.\d+)?)%([A-Za-z\u4e00-\u9fa5]+)/g);
        const concatResults = [...concatPairs];
        if (concatResults.length > 1) {
          concatResults.forEach((m) => pushRes(m[2], m[1]));
          continue;
        }

        let m = seg.match(/^(\d+(?:\.\d+)?)%([A-Za-z\u4e00-\u9fa5]+)$/); // 95%棉
        if (m) {
          pushRes(m[2], m[1]);
          continue;
        }

        m = seg.match(/^([A-Za-z\u4e00-\u9fa5]+)(\d+(?:\.\d+)?)%$/); // 棉95%
        if (m) {
          pushRes(m[1], m[2]);
          continue;
        }

        if (percentReg.test(seg) && i + 1 < segs.length && nameReg.test(segs[i + 1])) {
          // 95% 棉
          pushRes(segs[i + 1], seg);
          i++;
          continue;
        }

        if (nameReg.test(seg) && i + 1 < segs.length && percentReg.test(segs[i + 1])) {
          // 棉 95%
          pushRes(seg, segs[i + 1]);
          i++;
          continue;
        }

        if (nameReg.test(seg)) {
          // 单独材质名（可能是”棉”）
          results.push({ valueName: seg, percentageValue: '100', unitName: '%' });
        }
      }

      // 如果解析为空，且整体仅为一个材质名，默认 100%
      if (!results.length) {
        const onlyName = text.match(/^([A-Za-z\u4e00-\u9fa5]+)$/);
        if (onlyName) pushRes(onlyName[1], '100');
      }

      return results;
    },
    onCancel() {
      this.visible = false;
      this.materialText = '';
    },
    onConfirm() {
      if(!this.materialText) {
        return this.$message.warning('输入内容不能为空！')
      }
      const parsed = this.parseMaterial(this.materialText);
      this.$emit('confirm', parsed);
      this.onCancel();
    },
  },
};
</script>
<style lang="scss" scoped>
/* 解析示例样式 */
.parse-helper {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  padding: 10px 12px;
  font-size: 13px;
  color: #303133;
}
.parse-helper__header {
  display: grid;
  grid-template-columns: 1fr 60px 1fr;
  align-items: center;
  margin-bottom: 8px;
  font-weight: 600;
}
.parse-helper__before-title {
  color: #f56c6c; /* Element danger 色 */
}
.parse-helper__after-title {
  color: #67c23a; /* Element success 色 */
  text-align: right;
}
.parse-helper__arrow-title {
  text-align: center;
  color: #a0cfff; /* 淡蓝箭头 */
}
.parse-helper__list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.parse-helper__row {
  display: grid;
  grid-template-columns: 1fr 60px 1fr;
  align-items: center;
  padding: 6px 0;
  border-top: 1px dashed #f2f6fc;
}
.parse-helper__row:first-child {
  border-top: none;
}
.parse-helper__before {
  color: #606266;
}
.parse-helper__after {
  color: #303133;
  text-align: right;
}
.parse-helper__arrow {
  text-align: center;
  color: #a0cfff;
}
.material-popover {
  padding: 8px 10px;
}
.material-popover__title {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 8px;
}
.material-popover__footer {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
</style>
